import axios from 'axios'
import {store} from 'store'
import {logout} from 'store/actions/auth'
import {toast} from 'react-toastify'
import {STATUS_CODES, DEFAULT_MSG} from 'constants'
import {updateServerStatus} from 'store/actions/configs'
import {parseError} from 'utils'

const api = axios.create()

const onUnAuthorized = () => {
  store.dispatch(logout())
}

const setServerLive = () => {
  const storeState = store.getState()
  if (storeState.configs.isOnline) return
  store.dispatch(updateServerStatus(true))
}

const setServerDown = (error) => {
  const storeState = store.getState()
  if (storeState.configs.isOnline) {
    toast.error(parseError(error))
    store.dispatch(updateServerStatus(false))
  }
}

api.interceptors.request.use((config) => {
  const storeState = store.getState()
  const {token} = storeState.auth
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.defaults.headers.common['Content-Type'] = 'application/json'
api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

api.interceptors.response.use(
  (response) => {
    setServerLive()
    // Check if response is blob type (for file downloads)
    if (response.config.responseType === 'blob') {
      return response
    }

    if (response?.data?.meta?.code === STATUS_CODES.OK) return response.data
    if (response?.data?.meta?.code === STATUS_CODES.UNAUTHORIZED) onUnAuthorized()
    return Promise.reject(new Error(response?.data?.meta?.message || DEFAULT_MSG.StandardErrorMsg))
  },
  (error) => {
    if (error?.code === 'ERR_NETWORK') setServerDown(error)
    else if (error.response?.status === STATUS_CODES.UNAUTHORIZED) {
      setServerLive()
      onUnAuthorized()
    } else setServerLive()
    return Promise.reject(error)
  }
)

export default api
